import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { X_EXCLUDE_BASE_URL, X_SKIP_ALERT } from 'src/app/core/constants/http-headers';
import { SITE_DOWN_STATUS_CODES } from '../interceptors/error-handling.interceptor';
import { StartupService } from './startup.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionCheckService {
  constructor(
    private http: HttpClient,
    private startupService: StartupService
  ) {}

  hasInternetConnection(): Observable<boolean> {
    return this.http
      .get('/connection-check', {
        observe: 'response',
        headers: {
          [X_SKIP_ALERT]: '1',
          [X_EXCLUDE_BASE_URL]: '1'
        },
        params: {
          t: Date.now() // Timestamp for cache busting
        }
      })
      .pipe(
        map((response) => {
          return response.ok;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }

  hasServerConnection(): Observable<boolean> {
    // The choice of API call here is not significant.
    // We just need something lightweight to check if the server can be reached.
    // Return true as long as the API call succeeds.
    return this.startupService.isSessionExpired().pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        if (SITE_DOWN_STATUS_CODES.has(err.status)) {
          return of(false);
        }

        return of(true);
      })
    );
  }
}
